import React, { useState } from 'react';
import { trackFbEvent } from '../utils/fbpixel';
import { useCountdown } from '../utils/useCountdown';
type PlanId = 'standard' | 'vip';
export function PricingTable() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const [selected, setSelected] = useState<PlanId>('vip');
  const plans = {
    standard: {
      emoji: '📘',
      name: 'SISTEMA ORIGINAL',
      detail: '6 Tomos + 3 Bonus',
      oldPrice: '$39.990',
      price: '$19.990',
      value: 19990,
      label: 'QUIERO EL SISTEMA ORIGINAL →',
      url: 'https://biologiafemenina.com.ar/checkouts/cn/hWNDGi3D5MRcvrMwccGesYXi/es-ar?_r=AQABT1JBidE36-nLO_igsqjvNmmF7Cbur2YabfJL805uMlI'
    },
    vip: {
      emoji: '🏆',
      name: 'PACK COMPLETO',
      detail: '6 Tomos + 3 Bonus + NUTRICIONISTA + CUIDADOS',
      oldPrice: '$49.990',
      price: '$29.990',
      value: 29990,
      label: 'SÍ, QUIERO EL PACK COMPLETO →',
      url: 'https://biologiafemenina.com.ar/checkouts/cn/hWNDGi3RMqtuWghQnIAfu1EA/es-ar?_r=AQABRioaIP6Q5RSnCD37HzrOuBgbOxu2z4ybZJmc2Tpk8Ds'
    }
  };
  const pad = (n: number) => String(n).padStart(2, '0');
  const active = plans[selected];
  return <section id="compra" className="w-full bg-[#F8F5FC] px-4 py-8 sm:py-14 flex flex-col justify-center" style={{
    scrollMarginTop: 'calc(env(safe-area-inset-top, 0px) + 0.5rem)',
    minHeight: '100dvh'
  }} data-id="element-219">
      <div className="max-w-lg mx-auto w-full" data-id="element-220">
        {/* Countdown header */}
        <div className="text-center mb-5" data-id="element-221">
          <p className="text-brand-magenta text-[15px] sm:text-[18px] font-bold uppercase tracking-tight leading-tight" data-id="element-222">
            ⏰ PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO
          </p>
          <div className="flex items-start justify-center gap-6 mt-3" data-id="element-223">
            {[{
            v: hours,
            l: 'HS'
          }, {
            v: minutes,
            l: 'MIN'
          }, {
            v: seconds,
            l: 'SEG'
          }].map(({
            v,
            l
          }) => <div key={l} className="flex flex-col items-center" data-id="element-224">
                <span className="text-brand-text text-[34px] font-bold leading-none tabular-nums" data-id="element-225">
                  {pad(v)}
                </span>
                <span className="text-brand-muted text-[11px] font-semibold tracking-widest mt-1" data-id="element-226">
                  {l}
                </span>
              </div>)}
          </div>
          <p className="text-brand-muted text-[13px] mt-3" data-id="element-227">
            🔴 El precio sube cuando termina el contador
          </p>
        </div>

        {/* White checkout card */}
        <div className="bg-white rounded-[24px] p-5 sm:p-7 shadow-[0_8px_40px_rgba(74,0,128,0.10)]" data-id="element-228">
          <h2 className="text-[24px] sm:text-[28px] font-bold text-brand-text text-center leading-tight" data-id="element-229">
            Elegí tu plan:
          </h2>
          <p className="text-brand-muted text-[13px] sm:text-[14px] text-center mt-1.5 mb-5" data-id="element-230">
            Ambas opciones incluyen los 3 Bonus estratégicos
          </p>

          {/* Plan rows */}
          <div className="flex flex-col gap-3 mb-5" data-id="element-231">
            {/* Standard */}
            <button type="button" onClick={() => setSelected('standard')} aria-pressed={selected === 'standard'} className={`w-full text-left rounded-2xl p-4 border-2 transition-all ${selected === 'standard' ? 'border-brand-violet bg-brand-violet/[0.04]' : 'border-brand-gray bg-white'}`} data-id="element-232">
              <div className="flex items-center gap-3" data-id="element-233">
                <span className={`w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-all ${selected === 'standard' ? 'border-brand-violet' : 'border-brand-muted/40'}`} data-id="element-234">
                  {selected === 'standard' && <span className="w-2.5 h-2.5 rounded-full bg-brand-violet" data-id="element-235" />}
                </span>
                <div className="min-w-0 flex-1" data-id="element-236">
                  <p className="text-[14px] sm:text-[15px] font-bold text-brand-text leading-tight" data-id="element-237">
                    {plans.standard.emoji} {plans.standard.name}
                  </p>
                  <p className="text-brand-muted text-[12px] sm:text-[13px] leading-tight mt-0.5" data-id="element-238">
                    {plans.standard.detail}
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-239">
                  <p className="text-brand-muted text-[12px] line-through leading-tight" data-id="element-240">
                    {plans.standard.oldPrice}
                  </p>
                  <p className="text-brand-text text-[19px] font-bold leading-tight" data-id="element-241">
                    {plans.standard.price}
                  </p>
                </div>
              </div>
            </button>

            {/* VIP */}
            <button type="button" onClick={() => setSelected('vip')} aria-pressed={selected === 'vip'} className={`w-full text-left rounded-2xl p-4 border-2 transition-all ${selected === 'vip' ? 'border-brand-magenta bg-brand-magenta/[0.04]' : 'border-brand-gray bg-white'}`} data-id="element-242">
              <div className="flex items-center gap-3" data-id="element-243">
                <span className={`w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-all ${selected === 'vip' ? 'border-brand-magenta' : 'border-brand-muted/40'}`} data-id="element-244">
                  {selected === 'vip' && <span className="w-2.5 h-2.5 rounded-full bg-brand-magenta" data-id="element-245" />}
                </span>
                <div className="min-w-0 flex-1" data-id="element-246">
                  <div className="flex flex-wrap items-center gap-1.5 mb-0.5" data-id="element-247">
                    <p className="text-[14px] sm:text-[15px] font-bold text-brand-text leading-tight" data-id="element-248">
                      {plans.vip.emoji} {plans.vip.name}
                    </p>
                    <span className="bg-brand-violet text-white text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded" data-id="element-249">
                      ⭐ MÁS ELEGIDO
                    </span>
                    <span className="bg-brand-magenta/10 text-brand-magenta text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded" data-id="element-250">
                      AHORRÁS $20.000
                    </span>
                  </div>
                  <p className="text-brand-muted text-[12px] sm:text-[13px] leading-tight" data-id="element-251">
                    {plans.vip.detail}
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-252">
                  <p className="text-brand-muted text-[12px] line-through leading-tight" data-id="element-253">
                    {plans.vip.oldPrice}
                  </p>
                  <p className="text-brand-magenta text-[19px] font-bold leading-tight" data-id="element-254">
                    {plans.vip.price}
                  </p>
                </div>
              </div>
            </button>
          </div>

          {/* Dynamic CTA */}
          <a href={active.url} target="_blank" rel="noopener noreferrer" onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: selected === 'vip' ? 'Pack Completo' : 'Sistema Original',
          value: active.value,
          currency: 'ARS'
        })} className={`w-full block font-bold text-[15px] sm:text-[16px] rounded-xl py-4 text-center text-white transition-all ${selected === 'vip' ? 'bg-brand-magenta hover:brightness-110 shadow-[0_4px_24px_rgba(212,0,110,0.25)]' : 'bg-brand-violet hover:brightness-110 shadow-[0_4px_24px_rgba(74,0,128,0.20)]'}`} data-id="element-255">
            {active.label}
          </a>
          <p className="text-center text-brand-muted text-[12px] sm:text-[13px] italic mt-3" data-id="element-256">
            La opción más elegida por mujeres que no quieren volver a recaer
          </p>
        </div>

        {/* Trust footer */}
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-5 text-brand-muted text-[12px] font-medium" data-id="element-257">
          <span data-id="element-258">🔒 Pago seguro</span>
          <span data-id="element-259">⚡ Acceso en 5 min</span>
          <span data-id="element-260">🛡️ Garantía 7 días</span>
          <span data-id="element-261">💳 Tarjeta · Transferencia</span>
        </div>
      </div>
    </section>;
}